import React, { useMemo } from "react";
import {
  VictoryLabel,
  VictoryTheme,
  VictoryPie
} from "victory";

const ModelBookingsPie = ({ rentals }) => {


  const modelsBookings = useMemo(() => {
    const modelsB = [];

    (rentals || []).forEach((r) => {
      const rentalModel = r.model
      const rentalBookings = (r.bookings || [])
      const coincidenceIndex = modelsB.findIndex((modelB) => modelB.id === rentalModel._id)
      if (coincidenceIndex >= 0) modelsB[coincidenceIndex].num += rentalBookings.length
      else modelsB.push({
        id: rentalModel._id,
        num: rentalBookings.length,
        name: `${rentalModel.name} ${rentalModel.cubicCapacity}cc`
      })
    })

    return modelsB
  }, [rentals])

  return (
    <div className="w-100 h-100 position-relative">
      <h5 className="position-absolute text-center w-100" style={{ top: 0 }}>
        Numero de reservas por modelo
      </h5>
      <VictoryPie
        theme={VictoryTheme.material}
        barRatio={0.8}
        labelComponent={<VictoryLabel backgroundStyle={[{ fill: "#ffffff", opacity: 0.5 }]}/>}
        data={modelsBookings}
        x={"id"}
        y={"num"}
        labelRadius={({ innerRadius }) => innerRadius + 50}
        labels={({ index }) => {
          const data = modelsBookings[index]
          return [data.name, `${data.num} reservas`]
        }}
      />
    </div>

  )

}

export default ModelBookingsPie